"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Chart = require("../../Chart");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getDerivedProps = function getDerivedProps(props) {
  var isCategorical = props.isCategorical,
    isTimeSeries = props.isTimeSeries,
    colors = props.colors,
    series = props.series,
    xAxis = props.xAxis,
    yAxis = props.yAxis,
    showLegend = props.showLegend;
  var showChart = _Chart.CalculateProps.validateProps(props, 'BarChart');

  /** Only show legend prop if series prop is explicitly set and property
   *  showLegend equals to true. */
  var derivedShowLegend = !!(series && showLegend);

  /**
   * Calculate Axis Props
   */
  var derivedXAxis = _Chart.CalculateProps.deriveAxis(xAxis, {
    isCategorical: isCategorical,
    isTimeSeries: isTimeSeries
  });

  /** yAxis will always be numerical (not categorical, not time series) */
  var derivedYAxis = yAxis ? _Chart.CalculateProps.deriveAxis(yAxis) : _Chart.CalculateProps.deriveAxis(function (x) {
    return x;
  });

  /**
   * Calculate Series
   */
  var derivedSeries = _Chart.CalculateProps.deriveSeries(series, derivedYAxis);
  var tooltipTitle = derivedXAxis.tooltipFormat;
  var tooltipRows = derivedSeries.map(function (s, index) {
    return {
      label: s.label,
      value: s.tooltipFormat,
      color: s.color || colors[index]
    };
  });

  /** We use `any` here because Flow cannot correctly interpolate usage of spread operator */
  var result = _objectSpread(_objectSpread({}, props), {}, {
    series: derivedSeries,
    showChart: showChart,
    tooltipRows: tooltipRows,
    tooltipTitle: tooltipTitle,
    showLegend: derivedShowLegend,
    xAxis: derivedXAxis,
    yAxis: derivedYAxis
  });
  return result;
};
var _default = exports["default"] = getDerivedProps;
//# sourceMappingURL=getDerivedProps.js.map